import { createPluginOptions } from "../create-plugin-options";

export const defaultVibrationEventSummaryOptions = createPluginOptions()({
	showEventInfo: true,
	showEventData: true,
	showEventOverpressure: false as boolean | undefined,
});

export type VibrationEventSummaryOptions = typeof defaultVibrationEventSummaryOptions;
